import { commonRequest } from "../../services/ApiCall";
import { Helpers } from "../../services/Helpers";


export const DashboardServices = {
    bookingCount : async (id) =>{
        return await commonRequest("get", `${Helpers.URL()}/api/admin/dashboard/bookingDetail`, {}, Helpers.token());
    },
    customerCount : async (id) =>{
        return await commonRequest("get", `${Helpers.URL()}/api/admin/dashboard/customerDetail`, {}, Helpers.token());
    },
    storefrontCount : async (id) =>{
        return await commonRequest("get", `${Helpers.URL()}/api/admin/dashboard/storefrontDetail`, {}, Helpers.token());
    },
    providerCount : async (id) =>{
        return await commonRequest("get", `${Helpers.URL()}/api/admin/dashboard/providerDetail`, {}, Helpers.token());
    },
    topServices: async (data) => {
        return await commonRequest("get", `${Helpers.URL()}/api/admin/dashboard/topServices?limit=${data.limit}&month=${data.month}`, data, Helpers.token());
    },
    topCategories: async (data) => {
        return await commonRequest("get", `${Helpers.URL()}/api/admin/dashboard/topCategories?month=${data.month}`, data, Helpers.token());
    },
    saleChart: async (data) => {
        return await commonRequest("get", `${Helpers.URL()}/api/admin/dashboard/yearlySaleDetails?year=${data.year}`, {}, Helpers.token());
    },
    monthlySaleCount: async () => {
        return await commonRequest("get", `${Helpers.URL()}/api/admin/dashboard/monthlySaleDetails`, {}, Helpers.token());
    },
    recentBookings : async (data) => {
        console.log("data:", data);
        const queryParams = new URLSearchParams();
        
        // Basic pagination and sorting parameters
        queryParams.append('page', data.page + 1);
        queryParams.append('limit', data.limit);
        
        // Search key
        if (data.filters.searchKey) {
            queryParams.append('searchKey', data.filters.searchKey);
        }
        
        // Sorting
        if (data.filters.sortKey) {
            queryParams.append('sortKey', data.filters.sortKey);
            queryParams.append('sortDirection', data.filters.sortDirection);
        }
        
        // Status filter - More robust handling
        if (data.filters.status && data.filters.status !== 'all') {
            // Handle both string and array cases
            const statuses = Array.isArray(data.filters.status) 
                ? data.filters.status 
                : [data.filters.status];
            
            statuses.forEach(status => {
                queryParams.append('bookingStatus', status);
            });
        }
        
        // Additional multi-column filters
        if (data.filters.filterOptions) {
            data.filters.filterOptions.forEach((filter, index) => {
                if (filter.fieldName && filter.value) {
                    queryParams.append(`filters[${index}][fieldName]`, filter.fieldName);
                    queryParams.append(`filters[${index}][operator]`, filter.operator);
                    queryParams.append(`filters[${index}][value]`, filter.value);
                    
                    if (index !== 0) {
                        queryParams.append(`filters[${index}][andOr]`, filter.andOr);
                    }
                    
                    if (filter.operator === 'between') {
                        queryParams.append(`filters[${index}][endValue]`, filter.endValue);                        
                    }
                }
            });
        }
        
        console.log("query string:", queryParams.toString());
        
        // Construct the full URL
        const url = `${Helpers.URL()}/api/admin/dashboard/recent-bookings?${queryParams.toString()}`;
    
        // Make the API call
        return await commonRequest("get", url, {}, Helpers.token());
    },
}